import { render, staticRenderFns } from "./AIAgent.vue?vue&type=template&id=f0fc1670&scoped=true"
import script from "./AIAgent.vue?vue&type=script&lang=js"
export * from "./AIAgent.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.vue?vue&type=style&index=0&id=f0fc1670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fc1670",
  null
  
)

export default component.exports